import { api } from 'services/api';
import { useAuth } from 'hooks/auth';

export function useCompany() {
  const { token } = useAuth();
  const getCompanies = async (): Promise<any> => {
    const { data } = await api.get('/companies?asList=1', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return data;
  };

  return { getCompanies };
}
